<template>
  <RightInfoPanelGeneric
    :value="summary"
    title-key="tools.special_cases.review_title"
    :items="items"
    :saving="saving"
    @save="$emit('save')"
    @back="$emit('back')"
  />
</template>

<script>
import moment from "moment";
import RightInfoPanelGeneric from "@/components/Common/RightInfoPanelGeneric.vue";

export default {
  name: "SpecialCaseRightPanel",
  components: { RightInfoPanelGeneric },
  props: {
    value: { type: Object, required: true },
    options: { type: Object, default: () => ({}) },
    mode: { type: String, required: true },
    saving: { type: Boolean, default: false },
  },
  computed: {
    summary() {
      const optionName = (list, uuid) => (list || []).find((item) => item.uuid === uuid)?.name || null;
      return {
        ...this.value,
        department_name: optionName(this.options.departments, this.value.department_uuid),
        season_name: optionName(this.options.seasons, this.value.season_uuid),
        // culture_name: optionName(this.options.cultures, this.value.culture_uuid),
        work_name: optionName(this.options.works, this.value.work_uuid),
        person_name: optionName(this.options.persons, this.value.person_uuid),
        machine_name: optionName(this.options.machines, this.value.machine_uuid),
        target_count: (this.value.target_uuids || []).length,
      };
    },
    items() {
      const items = [
        { labelKey: "tools.import_validator.department", path: "department_name", required: true },
        { labelKey: "common.season", path: "season_name", required: true },
        { labelKey: "common.work_name", path: "work_name", required: true },
      ];
      // if (this.mode === "assign") items.push({ labelKey: "common.culture", path: "culture_name", required: true });
      items.push(
        { labelKey: "tools.import_validator.person", path: "person_name", required: true },
        { labelKey: "tools.import_validator.work_machine_name", path: "machine_name", required: true },
        {
          labelKey: this.mode === "assign" ? "common.parcels" : "tools.special_cases.target_works",
          path: "target_count",
          required: true,
          formatter: (count) => count || "*",
        },
        {
          labelKey: "tools.import_validator.start_date",
          path: "work_started_at",
          required: true,
          formatter: (value) => (value && moment(value).isValid() ? moment(value).format("YYYY-MM-DD HH:mm") : "*"),
        },
        {
          labelKey: "tools.import_validator.end_date",
          path: "work_ended_at",
          required: true,
          formatter: (value) => (value && moment(value).isValid() ? moment(value).format("YYYY-MM-DD HH:mm") : "*"),
        },
        {
          labelKey: "tools.import_validator.net_surface_worked",
          path: "net_surface_worked",
          formatter: (value) => (value === null || value === undefined ? "*" : value),
        },
      );
      return items;
    },
  },
};
</script>